import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    backgroundColor: theme.colors.Background8,
    minHeight: "100dvh",
    paddingBottom: 20,
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    padding: "70px 16px 16px 16px",
  },

  itemImage: {
    borderRadius: theme.radius.large,
    width: "fit-content",
    height: 200,
    backgroundColor: theme.colors.Background7,
  },

  headerSection: {
    paddingBottom: theme.spacing.space4,
  },

  price: {
    color: "#00c853 !important",
  },

  tabsList: {
    padding: 0,
  },

  tabContent: {
    height: 400,
    overflowY: "auto",
  },
}));